import { formatIsoDate } from "../../utils/function";

export const mapCdrList = (list) => {
  return list.map((el) => ({
    ...el,
    create_time: formatIsoDate(el.create_time.$date),
    complete_time: formatIsoDate(el.complete_time.$date),
  }));
};
